<template>
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
      <div class="card bcard mb-4">
        <div class="card-body px-4 px-lg-5">
          <div class="text-center">
            <h2 class="text-dark-m2">
              イベント情報送信
            </h2>
            <br>
            <h6 class="text-secondary-d2">
              {{ title }}
            </h6>
          </div>


          <div v-if="form.imageUploadFlag === '1' && form.stepIndex === '1'" class="mt-4">
            <div class="row text-600 text-95 text-secondary-d3 brc-green-l1 py-25 border-y-2 justify-content-center">
              <input type="file" ref="control" class="d-none" accept="image/*" @change="fileChange">
              <button @click="upload" type="button" class="btn btn-app btn-primary my-1" id="btn-app-1">
                <i class="d-block h-6 fa fa-camera text-190"></i>
              </button>
            </div>
          </div>
          
          
          <form v-else class="mt-lg-3" autocomplete="off">
            <div class="form-group row">
              <div class="col-sm-3 col-form-label text-sm-right pr-0">
                <label class="mb-0">
                  労働組合名
                </label>
              </div>
              <div class="col-sm-5">
                <input v-model="form.union" type="text" class="form-control" />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3 col-form-label text-sm-right pr-0">
                <label for="id-form-field-1" class="mb-0">
                  氏名
                </label>
              </div>
              <div class="col-sm-5">
                <input v-model="form.username" type="text" class="form-control" />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3 col-form-label text-sm-right pr-0">
                <label for="id-form-field-1" class="mb-0">
                  事業所名
                </label>
              </div>
              <div class="col-sm-5">
                <input v-model="form.company" type="text" class="form-control" />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3 col-form-label text-sm-right pr-0">
                <label for="id-form-field-1" class="mb-0">
                  郵便番号
                </label>
              </div>
              <div class="col-sm-5">
                <input v-model="form.zipcode" type="text" class="form-control" placeholder="ハイフン不要" v-on:change="checkZipcode" />
              </div>
              <div v-if="this.validation.zipcode" class="col-sm-4 text-sm-left col-form-label">
                <label class="mb-0 text-70 text-danger-m1">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>  半角英数字のみ使用できます
                </label>
              </div>
            </div>
            
            <div class="form-group row">
              <div class="col-sm-3 col-form-label text-sm-right pr-0">
                <label for="id-form-field-1" class="mb-0">
                  事業所住所
                </label>
              </div>
              <div class="col-sm-5">
                <input v-model="form.address" type="text" class="form-control" />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3 col-form-label text-sm-right pr-0">
                <label for="id-form-field-1" class="mb-0">
                  事業所電話番号
                </label>
              </div>
              <div class="col-sm-5">
                <input v-model="form.telno" type="text" class="form-control" placeholder="ハイフン不要" v-on:change="checkTelno" />
              </div>
              <div v-if="this.validation.telno" class="col-sm-4 text-sm-left col-form-label">
                <label class="mb-0 text-70 text-danger-m1">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>  半角英数字のみ使用できます
                </label>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3 col-form-label text-sm-right pr-0">
                <label for="id-form-field-1" class="mb-0">
                  クイズの回答
                </label>
              </div>
              <div class="col-sm-5">
                <input v-model.trim="form.price" type="text" class="form-control" />
              </div>
            </div>

            <div class="mt-5 border-t-1 brc-secondary-l2 py-35 mx-n25">
              <div class="col-12 text-nowrap d-flex justify-content-between">
                <button v-bind:disabled="form.stepIndex === '1'" @click="back" class="btn btn-outline-lightgrey btn-bold px-4" type="reset">
                  <i class="fa fa-arrow-left mr-1"></i>
                  戻る
                </button>

                <button @click="confirm"  class="btn btn-info btn-bold ml-2 px-4" type="button">
                  確認
                  <i class="fa fa-arrow-right ml-1"></i>
                </button>
              </div>
            </div>
          </form>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { API } from 'aws-amplify';

export default {
  name: 'Home',
  data(){
    return {
      form: {
        union: '',
        username: '',
        company: '',
        zipcode:'',
        address: '',
        telno: '',
        price: '',
        title: 'ステップ３．確認と送信',
        stepIndex: '1',
        imageUploadFlag: '1',
      },
      validation: {
        zipcode: false,
        telno: false,
      },
      title: 'ステップ１：写真を撮影または写真アップロード',
    }
  },
  created() {
    this.fetchData();
  },
  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      'req',
      'saved'
    ])
  },
  mounted() {
    if(this.req){
      this.form = JSON.parse(JSON.stringify(this.req))
    }
  },
  methods: {
    fetchData(){
      this.$loading.open();
      API.get('apiReceiptPaper', '/iuf', {}).then((rs) => {
        this.form.imageUploadFlag = rs.imageUploadFlag
        if (this.form.imageUploadFlag === '1') {
          if(this.form.stepIndex === '1') {
            this.title = 'ステップ１：写真を撮影または写真アップロード';
          } else {
            this.title = 'ステップ２：以下の項目を入力';
          }
          this.form.title = 'ステップ３．確認と送信';
        } else {
          this.title = 'ステップ１：以下の項目を入力';
          this.form.title = 'ステップ２．確認と送信';
        }
        this.$loading.hide();
      });
    },
    upload(){
      this.$refs.control.click();
    },
    next(){
      this.title = 'ステップ２：以下の項目を入力';
      this.form.stepIndex = '2';
    },
    fileChange(e){

      const files = this.$refs.control.files;

      const page = this;

      if(files.length > 0){
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);

        reader.onload = function(e) {
          page.$store.commit("changeImage",{
            file: files[0],
            url: this.result
          })
        };

        this.title = 'ステップ２：以下の項目を入力';
        this.form.stepIndex = '2';
      }
    },
    back(){
      this.title = 'ステップ１：写真を撮影または写真アップロード';
      this.form.stepIndex = '1';
    },
    confirm(){
      if (!this.validation.zipcode && !this.validation.telno) {
        this.$store.commit("updateInfo",this.form)
        this.$router.push({ name: 'Save' })
      }
    },
    checkZipcode(){
      const result = this.form.zipcode.match(/^(\d*)?/u)
      this.validation.zipcode = result[0] != this.form.zipcode
    },
    checkTelno(){
      const result = this.form.telno.match(/^(\d*)?/u)
      this.validation.telno = result[0] != this.form.telno
    },
  }
};
</script>
